import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Account } from '@app/models/account';
import { AccountType } from '@app/models/account-type';
import { LinkedAccountItem } from '@app/models/linked-account-item';

@Component({
    selector: 'app-linked-account-popup',
    templateUrl: './linked-account-popup.component.html',
    styleUrls: ['./linked-account-popup.component.css'],
    standalone: false
})
export class LinkedAccountPopupComponent implements OnChanges {

  @Input() selectedLinkedAccount: LinkedAccountItem;
  @Input() displaySearchDialog: boolean;
  @Input() loadAccount: boolean;
  @Input() allowSelectAccountType: boolean;
  @Input() kindOfAccountType: number;
  @Output() onSubmit = new EventEmitter<LinkedAccountItem>();
  @Output() onCancel = new EventEmitter();
  
  selectedAccount: any;

  constructor() { }

  ngOnChanges(): void {
    this.selectedAccount = undefined;
    if(this.selectedLinkedAccount){
      if(this.selectedLinkedAccount.typeCode){
        this.selectedAccount = new AccountType();
        this.selectedAccount.code = this.selectedLinkedAccount.typeCode;
      }else{
        this.selectedAccount = new Account();
        this.selectedAccount.id = this.selectedLinkedAccount.id;
        this.selectedAccount.number = this.selectedLinkedAccount.number;
      }
    }
  }

  composeAccountType(accountType: AccountType) {    
    if (accountType) {
      let item = new LinkedAccountItem();
      item.type = true;
      item.number = null;
      item.id = null;
      item.typeCode = accountType.code;
      item.inputValue = accountType.code;
      return item;
    }
    return undefined;
  }

  composeAccount(account: Account) {
    if (account) {
      let item = new LinkedAccountItem();
      item.account = true;
      item.number = account.number;
      item.id = account.id;
      item.typeCode = null;
      item.inputValue = account.number;
      return item;
    }
    return undefined;
  }

  composeNoAccount() {
    let item = new LinkedAccountItem();
    item.account = true;
    item.number = null;
    item.id = null;
    item.typeCode = null;
    item.inputValue = null;
    return item;
  }
  
  cancelSearch() {
    this.onCancel.emit();
  }

  onSelect(event) {
    if (event) {
      if(event.number)
      {
        return this.onSubmit.emit(this.composeAccount(event));
      }
      if (event.code) {
        this.onSubmit.emit(this.composeAccountType(event));
      }
    } else {
      this.onSubmit.emit(this.composeNoAccount());
    }
  }

}
